"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var cancel_button_component_1 = require("../../cancel-button/cancel-button.component");
var MobileCancelButtonComponent = /** @class */ (function (_super) {
    __extends(MobileCancelButtonComponent, _super);
    function MobileCancelButtonComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MobileCancelButtonComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'mobile-cancel-button',
            template: "\n      <button mat-icon-button\n              [id]=\"id\" (click)=\"onClick()\">\n        <svg class=\"sis-icon\">\n          <use xlink:href=\"icons/core.svg#close\"></use>\n        </svg>\n      </button>\n    "
        })
    ], MobileCancelButtonComponent);
    return MobileCancelButtonComponent;
}(cancel_button_component_1.CancelButtonComponent));
exports.MobileCancelButtonComponent = MobileCancelButtonComponent;
//# sourceMappingURL=mobile-cancel-button.component.js.map